import { LitElement, html, css } from 'lit';
import { customElement, state } from 'lit/decorators.js';
import { serviceState, onServiceStateChange } from '../state/service-state.js';

/**
 * Abonelik sona erdiğinde fiyatları TAMAMEN örten tam ekran katman.
 *
 * Neden bant değil de örtü: bandın altında donmuş eski fiyat okunmaya devam
 * ederdi. Vitrine bakan müşteri bayat altın fiyatını canlı sanabilir — bu yüzden
 * fiyatlar görünmez olmalı, yalnız uyarmak yetmez.
 *
 * Metin dış müşteriye de görünür (dükkâna gelen kişi okur): suçlayıcı değil,
 * teknik değil, kısa. "Ödenmedi" gibi bir ifade işletmeyi müşterisinin önünde
 * zor durumda bırakır — o bilgi panele ve e-postaya aittir, vitrine değil.
 */
@customElement('fp-service-overlay')
export class FpServiceOverlay extends LitElement {
    @state() private suspended = serviceState.suspended;

    private off?: () => void;

    static styles = css`
        :host {
            position: fixed;
            inset: 0;
            z-index: 10000;
            display: none;
        }
        :host([data-on]) {
            display: block;
        }
        .veil {
            width: 100%;
            height: 100%;
            background: #0b1020;
            color: #e2e8f0;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            gap: 1.2rem;
            text-align: center;
            padding: 2rem;
            box-sizing: border-box;
            font-family: 'Inter', system-ui, sans-serif;
        }
        .title {
            font-size: clamp(1.6rem, 5vh, 3.2rem);
            font-weight: 700;
            letter-spacing: -0.01em;
        }
        .sub {
            font-size: clamp(1rem, 2.6vh, 1.6rem);
            color: #94a3b8;
            max-width: 28ch;
            line-height: 1.45;
        }
    `;

    connectedCallback(): void {
        super.connectedCallback();
        this.off = onServiceStateChange(() => {
            this.suspended = serviceState.suspended;
            this.toggleAttribute('data-on', this.suspended);
        });
        this.toggleAttribute('data-on', this.suspended);
    }

    disconnectedCallback(): void {
        this.off?.();
        super.disconnectedCallback();
    }

    render() {
        if (!this.suspended) return html``;

        return html`
            <div class="veil">
                <div class="title">Fiyat gösterimi durduruldu</div>
                <div class="sub">Bu ekran şu anda güncel fiyat almıyor.</div>
            </div>
        `;
    }
}
